<template>
  <main
    id="create-item-page"
    class="page-container"
    v-if="$route.name === 'listini-add-item'"
  >
    <button type="button" class="back-btn" @click="goBack">
      <i class="fa-solid fa-arrow-left"></i> Indietro
    </button>
    <form class="create-item-form" @submit.prevent="onSubmit">
      <!-- [sc-49299] campi in comune con la creazione dal preventivo -->
      <FormArticolo
        ref="formArticolo"
        :category="category"
        @update:valido="valido = $event"
      />

      <hr />

      <div class="save-button-container">
        <button
          id="create-item-button"
          class="primary-btn"
          type="submit"
          :disabled="!canSave"
          :aria-disabled="!canSave"
          :title="
            !canSave
              ? 'Compila i campi obbligatori (*) e correggi quelli in rosso'
              : 'Salva articolo'
          "
        >
          Salva
        </button>
      </div>
    </form>

    <VueFinalModal
      v-model="showBackModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showBackModal = false"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Tornare indietro?</h3>
        <p class="modal__subtitle">Le modifiche non salvate andranno perse.</p>
        <div class="modal-actions">
          <button class="secondary-btn" @click="showBackModal = false">
            Annulla
          </button>
          <button class="primary-btn confirm-btn" @click="confirmGoBack">
            Conferma
          </button>
        </div>
      </template>
    </VueFinalModal>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import FormArticolo from "@/components/FormArticolo.vue";

export default {
  name: "CreateItemPage",
  components: { FormArticolo },
  beforeRouteLeave(to) {
    if (this.navigationConfirmed || to.name === "login") {
      this.navigationConfirmed = false;
      return true;
    }
    this.pendingNavigation = to;
    this.showBackModal = true;
    return false;
  },
  data() {
    return {
      showBackModal: false,
      pendingNavigation: null,
      navigationConfirmed: false,
      valido: false,
    };
  },
  computed: {
    category() {
      return decodeURIComponent(this.$route.params.category || "");
    },
    canSave() {
      return this.valido;
    },
  },
  methods: {
    goBack() {
      this.pendingNavigation = null;
      this.showBackModal = true;
    },
    confirmGoBack() {
      this.navigationConfirmed = true;
      this.showBackModal = false;
      if (this.pendingNavigation) {
        this.$router.push(this.pendingNavigation);
      } else {
        // all'elenco, non alla pagina prima nella cronologia: dopo un
        // ricaricamento era di nuovo questa
        this.$router.push({
          name: "listini-category",
          params: { category: this.category },
        });
      }
    },
    ...mapActions(["createItem"]),

    async onSubmit() {
      if (!this.canSave) return;
      const payload = this.$refs.formArticolo.payload();

      try {
        const res = await this.createItem(payload);
        this.$toast.success(res.data?.message || "Articolo creato!");
        this.$refs.formArticolo.reset();
        setTimeout(() => {
          this.$router.push({
            name: "listini-category",
            params: { category: this.category },
          });
        }, 800);
      } catch (err) {
        if (
          err.response?.status === 409 &&
          err.response?.data?.code === "ITEM_CODE_DUPLICATE"
        ) {
          this.$toast.error(
            "Questo codice è già utilizzato da un altro articolo."
          );
        } else {
          this.$toast.error(
            err.response?.data?.message ||
              err.response?.data?.error ||
              "Errore durante la creazione."
          );
        }
      }
    },
  },
};
</script>

<style src="@/css/CreateItemPage.css"></style>
